import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a439b1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "QuestionSolutionReportManageView" }

import { onMounted, ref, watchEffect } from "vue";
import message from "@arco-design/web-vue/es/message";
import moment from "moment";
import { useRouter } from "vue-router";
import {
  QuestionSolutionReport,
  QuestionSolutionReportControllerService,
} from "../../../generated";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionSolutionReportManageView',
  setup(__props) {

document.title = "题解举报管理";

const router = useRouter();
const tableRef = ref();

const dataList = ref([]);
const total = ref(0);
const searchParams = ref({
  id: undefined,
  userId: undefined,
  solutionId: undefined,
  reportedUserId: undefined,
  pageSize: 10,
  current: 1,
});

const loadData = async () => {
  const res =
    await QuestionSolutionReportControllerService.listQuestionSolutionReportByPageUsingPost(
      {
        ...searchParams.value,
        sortField: "createTime",
        sortOrder: "descend",
      }
    );
  if (res.code === 0) {
    dataList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error("加载失败，" + res.message);
  }
};

/**
 * 监听 searchParams 变量，改变时触发页面的重新加载
 */
watchEffect(() => {
  loadData();
});

/**
 * 页面加载时，请求数据
 */
onMounted(() => {
  loadData();
});

const columns = [
  {
    title: "id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "检举人id",
    dataIndex: "userId",
    align: "center",
  },
  {
    title: "被检举题解的id",
    dataIndex: "solutionId",
    align: "center",
  },
  {
    title: "被检举人id",
    dataIndex: "reportedUserId",
    align: "center",
  },
  {
    title: "创建时间",
    slotName: "createTime",
    align: "center",
  },
  {
    title: "操作",
    slotName: "optional",
    align: "center",
  },
];

/**
 * 分页
 * @param page
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/**
 * 分页大小
 * @param size
 */
const onPageSizeChange = (size: number) => {
  searchParams.value = {
    ...searchParams.value,
    pageSize: size,
  };
};

/**
 * 删除
 * @param questionSolutionReport
 */
const doDelete = async (questionSolutionReport: QuestionSolutionReport) => {
  const res =
    await QuestionSolutionReportControllerService.deleteQuestionSolutionReportUsingPost(
      questionSolutionReport.id as number
    );
  if (res.code === 0) {
    message.success("删除成功");
    loadData();
  } else {
    message.error("删除失败");
  }
};
/**
 * 确认违规并删除
 * @param questionSolutionReport
 */
const doDeleteAfterConfirm = async (
  questionSolutionReport: QuestionSolutionReport
) => {
  const res =
    await QuestionSolutionReportControllerService.deleteQuestionSolutionAfterConfirmUsingPost(
      {
        id: questionSolutionReport.id,
        solutionId: questionSolutionReport.solutionId,
      }
    );
  if (res.code === 0) {
    message.success("删除成功");
    loadData();
  } else {
    message.error("删除失败");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      model: searchParams.value,
      layout: "inline",
      style: {"justify-content":"center","align-content":"center","margin":"25px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { field: "id" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: searchParams.value.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.id) = $event)),
              placeholder: "搜索记录id",
              style: {"min-width":"220px","border-radius":"10px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { field: "userId" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: searchParams.value.userId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.userId) = $event)),
              placeholder: "搜索检举人id",
              style: {"min-width":"220px","border-radius":"10px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { field: "solutionId" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: searchParams.value.solutionId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchParams.value.solutionId) = $event)),
              placeholder: "搜索被检举题解id",
              style: {"min-width":"220px","border-radius":"10px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { field: "reportedUserId" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_search, {
              modelValue: searchParams.value.reportedUserId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchParams.value.reportedUserId) = $event)),
              placeholder: "搜索被检举人id",
              style: {"min-width":"220px","border-radius":"10px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_table, {
      "column-resizable": true,
      ref: tableRef.value,
      columns: columns,
      data: dataList.value,
      pagination: {
        showTotal: true,
        pageSize: searchParams.value.pageSize,
        current: searchParams.value.current,
        total: total.value,
        showJumper: true,
        showPageSize: true,
      },
      onPageChange: onPageChange,
      onPageSizeChange: onPageSizeChange
    }, {
      createTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD HH:mm:ss")), 1)
      ]),
      optional: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_popconfirm, {
              content: "确定要删除此记录吗?",
              type: "error",
              okText: "是",
              cancelText: "否",
              onCancel: _cache[4] || (_cache[4] = 
              () => {
                _unref(message).warning(`已取消`);
              }
            ),
              onOk: ($event: any) => (doDelete(record))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  shape: "round",
                  type: "outline",
                  status: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除 ")
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onOk"]),
            _createVNode(_component_a_popconfirm, {
              content: "确定要删除此记录吗?",
              type: "error",
              okText: "是",
              cancelText: "否",
              onCancel: _cache[5] || (_cache[5] = 
              () => {
                _unref(message).warning(`已取消`);
              }
            ),
              onOk: ($event: any) => (doDeleteAfterConfirm(record))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  shape: "round",
                  type: "outline",
                  status: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("确认违规并删除 ")
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onOk"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination"])
  ]))
}
}

})